angular.module('zc.commonApi')

.factory "ProjectLoginEvaluator", ($resource, $q, BaseProjectCrudService) ->
  class ProjectLoginEvaluator extends BaseProjectCrudService

  new ProjectLoginEvaluator(
    $resource
    $q
    "/api/projects/:projectId/login_evaluators/:id"
    "login_evaluator"
    "login_evaluators"
  )





// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/login_evaluator.service.coffee